(() => {
  'use strict';
  if (customElements.get('cooper-model-card')) return;
  class CooperModelCard extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-cooper-color]');
        if (button && button.closest('cooper-model-card') === this) this.select(button);
      });
      this.addEventListener('keydown', event => {
        const buttons = [...this.querySelectorAll('button[data-cooper-color]')];
        const index = buttons.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next === undefined) return;
        event.preventDefault(); buttons[next].focus(); this.select(buttons[next]);
      });
    }
    select(button) {
      const key = button.dataset.cooperColor;
      const template = [...this.querySelectorAll('template[data-cooper-template]')].find(item => item.dataset.cooperTemplate === key);
      const view = this.querySelector('[data-cooper-view]');
      if (!template || !view) return;
      view.replaceChildren(template.content.cloneNode(true));
      this.querySelectorAll('button[data-cooper-color]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const status = this.querySelector('[data-cooper-status]');
      if (status) status.textContent = button.getAttribute('aria-label');
    }
  }
  customElements.define('cooper-model-card', CooperModelCard);
})();
